import { ICoachProfileFormValues, MISSING_FIELD_TO_FORM_KEY } from './types'

export interface IFieldError {
  name: keyof ICoachProfileFormValues
  message: string
}

// Translates the backend `missingFields` (snake_case) returned by submitCoachProfile
// into form field errors, acting as a safety net behind client-side validation.
export const mapMissingFieldsToErrors = (missingFields: string[]): IFieldError[] =>
  missingFields.reduce<IFieldError[]>((errors, field) => {
    const name = MISSING_FIELD_TO_FORM_KEY[field]
    if (name) errors.push({ name, message: 'This field is required.' })
    return errors
  }, [])
